<template>
    <form class="reminder-form form-horizontal" @submit.prevent="submit()">
        
        <!-- <div class="form-group" :class="{ 'has-error': errors['canal_id'] }">
            <label for="canal_id" class="col-sm-4 control-label">Canal</label>
            <div class="col-sm-8">
                <input type="text" class="form-control" id="canal_id" v-model="data.canal_id" :maxlength="10">
                 
                <div class="help-block" v-for="(e,index) in errors['canal_id']" :key="index">{{e}}</div>
            </div>
        </div>  -->

        <div class="form-group" :class="{ 'has-error': errors['canal_id'] }">
            <label for="canal_id" class="col-sm-4 control-label">Canal</label>
            <div class="col-sm-7">
                <channel-select 
                id="canal_id" 
                v-model="data.canal_id" 
                :canales="this.canales" 
                >
                </channel-select>
                <!-- :disabled="this.backusr.role != 'admin'" -->
                <div class="help-block" v-for="e in errors['canal_id']"  >El campo canal es obligatorio.</div>
            </div>
        </div>

         <div class="form-group" :class="{'has-error': errors['accion']}">
            <label for="accion" class="col-sm-4 control-label">Canal disponible </label>
            <div class="col-sm-8">
                <el-switch v-model="data.accion" on-text="Si" off-text="No">
                </el-switch>
            </div>
        </div>

        <div class="form-group" :class="{'has-error': errors['status']}">
            <label for="status" class="col-sm-4 control-label">Activo </label>
            <div class="col-sm-8  ">
                <el-switch v-model="data.status" on-text="Si" off-text="No">
                </el-switch>
            </div>
        </div>

        <div class="form-group">
            <div class="col-sm-offset-4 col-sm-8">
                <a class="btn btn-default" :href="'backend/fichas/'+ this.page.id + '/channels'">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>
<style lang="scss" scoped>
    .el-select{
        display: block;
    }
    .el-picker-panel.el-date-picker.datepick1 {
        min-width: 295px !important;
    }
    .el-date-editor.el-input{
        min-width: 295px !important;
    }
    .subtitle {
        color: #757575;
        padding-top:20px !important;
        text-align: left !important;
    }
</style>
<script>
import ElementUI from 'element-ui';
import ElSelect from 'element-ui/lib/select';
import ElSwitch from 'element-ui/lib/switch';
import ElOption from 'element-ui/lib/option';
import ElDatePicker from 'element-ui/lib/date-picker';
import ChannelSelect from "./ChannelSelect.vue";
import ElInput from 'element-ui/lib/input';
import locale from 'element-ui/lib/locale/lang/es';
import Vue from 'vue';
import { Message } from 'element-ui';
Vue.use(ElementUI, { locale });

export default {
    data: function(){
        const data = {
            id: null,
            canal_id: null,
            ficha_id: null,
            orden: null,
            accion: null,
            status: null,
        };
        _.assign(data, this.action);
        
        return{
            data: data,
            errors: {}
        }
    },
    components:{
        ElSelect,
        ElSwitch,
        ElOption,
        ElDatePicker,
        ChannelSelect,
        ElInput,
    },
    props: [
        'page', 
        'action', 
        'canales', 
        'edit',
        'backusr'
    ],
    computed: {
        validateForm: function() { 
            this.errors = {};
            var error_canal_id = this.data.canal_id === '' || this.data.canal_id === null;
            var errores = {};
            if(error_canal_id){ 
                errores["canal_id"] = ["Debes de registrar un canal no puede estar vacío."]; 
            }
           
            if (error_canal_id){
                this.errors = errores;
                return true;
            }else{
                }
                return false;
        }
    },
    methods:{
        
        submit: function(){
            console.log("submit");
           
            var self = this;

            console.log(self.data);

            if (self.validateForm){
                self.$message.error('Revise los errores en el formulario antes de continuar.');
            }else{
                if (self.edit){
                    console.log("edit");
                    var url_axios = 'backend/fichas/'+ self.page.id + '/channels/' + self.data.id;
                    var method_axios = 'PUT';
                } else {
                    console.log("create");
                    var url_axios = 'backend/fichas/'+ self.page.id + '/channels/';
                    var method_axios = 'POST';
                }

                axios({
                    url: url_axios,
                    method: method_axios,
                    data: self.data,
                }).then(function(response){
                    console.log("response:");
                    console.log(response);
                    window.location.replace(response.data.redirect);
                }).catch(function(error){
                    alert(error);
                    self.errors = error.response.data.errors;
                });

            }
        }
    },
    mounted: function(){
       
    }
}
</script>